import * as React from "react"

import FooterNavigation from "./footer-navigation"

type Props = {
  utmSource: string
  utmMedium: string
  utmCampaign: string
  utmContent: string
}
const Footer = ({ utmSource, utmMedium, utmCampaign, utmContent }: Props) => (
  <div>
    <footer>
      <FooterNavigation
        utmSource={utmSource}
        utmMedium={utmMedium}
        utmCampaign={utmCampaign}
        utmContent={utmContent}
      />
    </footer>
  </div>
)

export default Footer
